import React from 'react';
import { StyleSheet, View, Text, TouchableOpacity } from 'react-native';

const StatsCard = ({ title, value }) => {
  return (
    <View style={styles.card}>
      <Text style={styles.title}>{title}</Text>
      <Text style={styles.value}>{value.toString()}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: 'white',
    borderRadius: 8,
    padding: 15,
    width: '30%',
    alignItems: 'center',
    elevation: 2,
    // Usar boxShadow en lugar de shadowColor, shadowOffset, etc.
    boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.1)',
  },
  title: {
    fontSize: 14,
    color: '#7f8c8d',
    marginBottom: 5,
    textAlign: 'center',
  },
  value: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#2c3e50',
  },
});

export default StatsCard;